<template>
    <div :class="{ 'modal': true, 'active': showModal }">

        <div class="modal-content">

            <div class="modal-content-header">
                <h3 v-if="employee.id">
                    {{ $t('label.editEmployee') }}
				</h3>
                <h3 v-else>
                    {{ $t('label.addEmployee') }}
				</h3>
                <span class="modal-content-header-close" @click.prevent="close(false)">
					<i aria-hidden="true" class="icon icon-close-large"></i>
				</span>
            </div>

            <div class="modal-content-body">
                <div class="row">

                    <div class="col-lg-5">
                        <avatar-widget ref="employeeAvatar"
                                :color="employee.color"
                                :colorpicker="true"
                                @colorChanged="colorChanged"
                                :upload="true"
                                v-model="employee.image"
                        >
                        </avatar-widget>
                    </div>
                    <form action="#" enctype="multipart/form-data" class="form col-lg-7" @submit.prevent>
                        <div class="row">
                            <div class="col-lg-12">
                                <input-widget
                                        :label="$t('label.person_name')"
                                        :placeholder="$t('label.person_name')"
                                        type="text"
                                        v-model="employee.name"
                                        validate="required"
                                        ref="focus"
                                ></input-widget>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <input-widget
                                        :label="$t('label.phone')"
                                        :placeholder="$t('label.phone')"
                                        type="text"
                                        v-model="employee.phone">
                                </input-widget>
                            </div>
                        </div>
                        <div class="row margin-bottom-10">
                            <div class="col-lg-12">
                                <input-widget
                                        :label="$t('label.email')"
                                        :placeholder="$t('label.email')"
                                        type="email"
                                        validate="email"
                                        v-model="employee.email">
                                </input-widget>
                                <div class="text-right" v-if="!employee.user_id && !!employee.email">
                                    <span v-if="employee.invitation" @click="invite"
                                          :class="{ 'invitation-link': true, 'disabled': !this.existingEmail }">{{ $t('button.resendInvitation') }}</span>
                                    <span v-else @click="invite"
                                          :class="{ 'invitation-link': true, 'disabled': !this.existingEmail }">{{ $t('button.invite') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="employee.user">
                            <div class="col-lg-12">
                                {{ $t('message.joinedSalonize') }}
                            </div>
                            <div class="col-lg-12">
                                <label class="checkbox-label">
                                    <span class="checkbox-label-marker">
                                        <input type="checkbox" v-model="employee.manager" />
                                        <span class="checkbox-label-flag"></span>
                                    </span>
                                        <span class="checkbox-label-text">
                                        {{ $t('label.manageOrganization') }}
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="button-wrapper-right margin-bottom-20">
                                    <input type="submit" :value="$t('button.save')"
                                           :class="{'button-full': true, 'loading': loading}"
                                           @click.prevent="validate"/>
                                    <span class="button-hollow" @click.prevent="close(false)">{{ $t('button.cancel') }}</span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
  import InputWidget from '@/components/widgets/InputWidget'
  import ColorPickerWidget from '@/components/widgets/ColorPickerWidget'
  import AvatarWidget from '@/components/widgets/AvatarWidget'

  export default {
    name: 'Employee',
    components: {AvatarWidget, InputWidget, ColorPickerWidget},
    props: ['data', 'show'],
    data () {
      return {
        showModal: false,
        employee: {},
        existingEmail: null,
        loading: false,
        loadingInvite: false
      }
    },
    watch: {
      show (value) {
        this.showModal = value
        if (value) {
          setTimeout(() => {
            this.$refs.focus.$el.querySelector('input').focus()
          }, 500)
        } else {
          this.employee.color = this.$refs.employeeAvatar.selectedColor
        }
      },
      data (value) {
        this.employee = value
        if (this.employee.id && this.employee.email) {
          this.existingEmail = this.employee.email
        } else {
          this.existingEmail = false
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      save () {
        this.loading = true

        let formData = this.createFormData()

        if (!this.employee.id) {
          this.$api.post('/v1/employees', formData, {
            'Content-Type': 'multipart/form-data'
          }).then(() => {
            this.close(true)
            this.$refs.employeeAvatar.remove()
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        } else {
          this.$api.post('/v1/employees/' + this.employee.id, formData, {
            'Content-Type': 'multipart/form-data'
          }).then(() => {
            this.close(true)
            this.$refs.employeeAvatar.remove()
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        }
      },
      createFormData () {
        let data = []
        data['name'] = this.employee.name
        data['phone'] = this.employee.phone
        data['color'] = this.employee.color
        data['email'] = this.employee.email
        data['manager'] = this.employee.manager ? 1 : 0

        if (typeof this.employee.image !== 'string') {
          data['image'] = this.employee.image
        }

        if (this.employee.image === null) {
          data['image_remove'] = 1
          data['image'] = null
        }

        data['note'] = this.employee.note

        let formData = new FormData()

        for (let entry in data) {
          if (data[entry] === null || typeof data[entry] === 'undefined') {
            continue
          }
          formData.append(entry, data[entry])
        }

        return formData
      },
      close (updated) {
        this.employee = {}
        this.existingEmail = false
        this.showModal = false
        this.$refs.employeeAvatar.remove()
        this.$emit('closed', {
          show: this.showModal,
          updated: updated
        })
      },
      colorChanged (value) {
        this.employee.color = value
      },
      toggleColorPicker () {
        this.$events.fire('colorpicker-toggle')
      },
      invite () {
        if (!this.existingEmail || this.employee.user) {
          return
        }
        this.loadingInvite = true
        this.$api.post('/v1/employees/' + this.employee.id + '/enable').then(() => {
          this.$events.fire('message-open', {
            type: 'success',
            message: this.$t('message.invitationSent')
          })
          this.loadingInvite = false
          this.existingEmail = false
        }).catch(error => {
          console.error(error)
          this.$events.fire('message-open', {
            type: 'error',
            message: this.$t('message.somethingWentWrong')
          })
          this.loadingInvite = false
        })
      },
      validateEmployeeEmail () {
        return this.employee.id && this.employee.email
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Employees/EmployeeModal.vue